import { Timestamp } from 'firebase/firestore';
import { useEffect, useState } from 'react';

interface UseDobInputReturn {
  value: Timestamp | Date | string;
  setValue: (value: Date) => void;
  stringValue: string;
  setStringValue: (value: string) => void;
  setYear: (value: number | string) => void;
  setMonth: (value: number | string) => void;
  setDay: (value: number | string) => void;
  bindYear: {
    value: number | string;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    onBlur: () => void;
  };
  bindMonth: {
    value: number | string;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    onBlur: () => void;
  };
  bindDay: {
    value: number | string;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    onBlur: () => void;
  };
  reset: () => void;
  bind: {
    value: Timestamp | Date | string;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  };
  valid: boolean;
  setValid: (valid: boolean) => void;
  touched: boolean;
}

const useDobInput = (initialValue?: number): UseDobInputReturn => {
  let initialYear = '';
  let initialMonth = '';
  let initialDay = '';
  let initialDate: any = '';
  let initialDateString = '';

  if (initialValue) {
    initialDate = new Date(initialValue * 1000);
    if (initialDate.valueOf()) {
      initialYear = initialDate.getFullYear();
      initialMonth = initialDate.getMonth();
      initialDay = initialDate.getDate();
      initialDateString = `${initialYear}-${initialMonth + 1}-${initialDay}`;
    }
  }

  const [value, setValue] = useState<Date | Timestamp | string>(
    initialDate,
  );
  const [stringValue, setStringValue] = useState<string>(initialDateString);
  const [year, setYear] = useState<number | string>(initialYear);
  const [month, setMonth] = useState<number | string>(initialMonth);
  const [day, setDay] = useState<number | string>(initialDay);

  const [touched, setTouched] = useState({
    month: false,
    year: false,
    date: false,
  });

  const [valid, setValid] = useState(false);

  useEffect(() => {
    const checkValid = () => {
      if (Number(year) > 0 && month !== '' && Number(month) >= 0 && Number(day) > 0) {
        setValid(true);
      } else {
        setValid(false);
      }
    };
    const newDate = new Date(Number(year), Number(month), Number(day));
    setValue(newDate);
    setStringValue(`${year}-${(Number(month) + 1).toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`);
    checkValid();
  }, [year, month, day]);

  return {
    value,
    setValue,
    stringValue,
    setStringValue,
    setYear,
    setMonth,
    setDay,
    bindYear: {
      value: year,
      onChange: (event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
        setYear(event.target.value === '' ? '' : Number(event.target.value));
      },
      onBlur: () => {
        setTouched({
          ...touched,
          year: true,
        });
      },
    },
    bindMonth: {
      value: month,
      onChange: (event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
        setMonth(event.target.value === '' ? '' : Number(event.target.value));
      },
      onBlur: () => {
        setTouched({
          ...touched,
          month: true,
        });
      },
    },
    bindDay: {
      value: day,
      onChange: (event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
        setDay(event.target.value === '' ? '' : Number(event.target.value));
      },
      onBlur: () => {
        setTouched({
          ...touched,
          date: true,
        });
      },
    },
    reset: () => {
      setValue('');
      setStringValue('');
      setYear('');
      setMonth('');
      setDay('');
    },
    bind: {
      value,
      onChange: (event: React.ChangeEvent<HTMLSelectElement>) => {
        setValue(event.target.value);
      },
    },
    valid,
    setValid,
    touched: touched.date && touched.year && touched.month,
  };
};

export default useDobInput;
